<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search"
          >搜索</el-button
        >
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
      <template v-slot:expand>
        <div style="margin-bottom: 20px; vertical: middle">
          <p class="inline-p">操作列表：</p>
          <!-- <el-button
            style="margin-left:20px;"
            type="primary"
            @click="invalidList"
            >批量作废</el-button
          > -->
          <el-button style="margin-left: 20px" type="text" @click="exportList"
            >打印选中的编号信息</el-button
          >
          <!-- <el-button
            style="margin-left:20px;"
            @click="push"
            :disabled="pushDisabled"
            >推送</el-button
          > -->
          <el-button
            style="transform: translateY(10px); float: right"
            type="primary"
            @click="visible = true"
            >新增车辆信息</el-button
          >
        </div>
      </template>
    </customize-page>

    <el-dialog
      :visible.sync="visible"
      custom-class="dialog"
      @close="resetForm"
      title="新增车辆信息"
    >
      <el-form label-width="110px">
        <p>提交信息后，系统将自动生成对应的编号</p>
        <div class="row-div" v-for="(item, index) in form" v-bind:key="index">
          <el-row>
            <h3>核放单{{ index + 1 }}</h3>
            <el-col :span="12">
              <el-form-item label="车辆信息" prop="licensePlate">
                <!-- <el-input
                  placeholder="请输入"
                  v-model="item.licensePlate"
                ></el-input> -->
                <el-select
                  v-model="item.licensePlate"
                  filterable
                  allow-create
                  default-first-option
                  @change="selectChange"
                  placeholder="请输入车牌信息"
                >
                  <el-option
                    v-for="(ite, inde) in vehicleList"
                    :key="inde"
                    :label="ite.licensePlate"
                    :value="getNewValue(ite, index)"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆自重(KG)" prop="vehicleWeight">
                <el-input
                  placeholder="请输入"
                  v-model="item.vehicleWeight"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- </el-row>

          <el-row> -->
            <el-col :span="12">
              <el-form-item label="核放单类型" prop="isEmptyVehicleCheck">
                <el-select
                  v-model="item.isEmptyVehicleCheck"
                  default-first-option
                  placeholder="请选择核放单类型"
                  @change="typeChange"
                >
                  <el-option
                    v-for="(ite, inde) in [
                      {
                        label: '二线进出区核放',
                        value: '0',
                      },
                      {
                        label: '空车核放',
                        value: '1',
                      },
                    ]"
                    :key="inde"
                    :label="ite.label"
                    :value="ite.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车架号" prop="vehicleFrameNo">
                <el-input
                  placeholder="请输入"
                  v-model="item.vehicleFrameNo"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- </el-row>
          <el-row> -->
            <el-col :span="12">
              <el-form-item label="快递公司" prop="carrierCodeDesc">
                <el-select
                  placeholder="支持模糊搜索"
                  multiple
                  v-model="item.carrierCodeDesc"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in carrierAllList"
                    :key="index"
                    :value="item.name"
                    >{{ item.name }}</el-option
                  >
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车架重" prop="vehicleFrameWeight">
                <el-input
                  placeholder="请输入"
                  v-model="item.vehicleFrameWeight"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- </el-row>
          <el-row> -->
            <el-col :span="12">
              <el-form-item label="进出区标志" prop="checklistType">
                <el-select
                  v-model="item.checklistType"
                  default-first-option
                  placeholder="请选择核放单类型"
                >
                  <el-option
                    v-for="(ite, inde) in [
                      {
                        label: '进区',
                        value: 'SECOND_IN',
                      },
                      {
                        label: '出区',
                        value: 'SECOND_OUT',
                      },
                    ]"
                    :key="inde"
                    :label="ite.label"
                    :value="ite.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="item.isEmptyVehicleCheck === '0'" :span="12">
              <el-form-item
                class="none"
                label="关联核注清单"
                prop="endorsementOrderNos"
              >
                <el-select
                  v-model="item.endorsementOrderNos"
                  multiple
                  placeholder="请选择关联核注清单"
                >
                  <el-option
                    v-for="(ite, inde) in nuclearNoteList"
                    :key="inde"
                    :label="ite.endorsementOrderNo"
                    :value="ite.endorsementOrderNo"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请人" prop="applicant">
                <el-input
                  placeholder="请输入"
                  v-model="item.applicant"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- </el-row>
          <el-row> -->
            <el-col :span="12">
              <el-form-item label="" prop="weightRequired">
                <el-checkbox v-model="item.weightRequired"
                  >勾选后操作台包裹需要称重</el-checkbox
                >
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="" prop="enableCPOrderValid">
                <el-checkbox v-model="item.enableCPOrderValid"
                  >勾选后打开子母单校验</el-checkbox
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-button
            v-if="index > 0"
            type="text"
            size="middle"
            @click="form.splice(index, 1)"
            >删除</el-button
          >
        </div>
        <el-button type="text" size="middle" @click="addForm"
          ><i class="el-icon-circle-plus-outline el-icon--left"></i
          >新增</el-button
        >
      </el-form>
      <template slot="footer">
        <el-button style="margin-right: 30px" @click="resetForm"
          >取消</el-button
        >
        <el-button type="primary" @click="submitForm">确定</el-button>
      </template>
    </el-dialog>

    <el-dialog
      :visible.sync="editVisible"
      custom-class="dialog"
      @close="resetEditForm"
      title="编辑车辆信息"
    >
      <el-form label-width="110px">
        <el-form-item label="车辆信息" prop="licensePlate">
          <el-select
            v-model="editRow.licensePlate"
            filterable
            allow-create
            default-first-option
            @change="selectChange2"
            placeholder="请输入车牌信息"
          >
            <el-option
              v-for="(ite, inde) in vehicleList"
              :key="inde"
              :label="ite.licensePlate"
              :value="getNewValue(ite, 0)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车自重" prop="vehicleWeight">
          <el-input
            placeholder="请输入"
            v-model="editRow.vehicleWeight"
          ></el-input>
        </el-form-item>
        <el-form-item label="车架号" prop="vehicleFrameNo">
          <el-input
            placeholder="请输入"
            v-model="editRow.vehicleFrameNo"
          ></el-input>
        </el-form-item>
        <el-form-item label="车架重" prop="vehicleFrameWeight">
          <el-input
            placeholder="请输入"
            v-model="editRow.vehicleFrameWeight"
          ></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button style="margin-right: 30px" @click="resetEditForm"
          >取消</el-button
        >
        <el-button type="primary" @click="submitEditForm">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import popover from "@/components/pop-over";
import Page from "@/mixin/Page";
import { formatDate } from "@/utils/common";

import { mapState, mapActions } from "vuex";

export default {
  components: {
    CustomizePage,
    popover,
  },
  mixins: [Page],
  mounted() {
    this.fetchCarrierAllList();
    this.fetch();
    this.fetchNuclearNoteList();
    this.queryVehicleList({
      request: {
        type: "ALL",
      },
    }).then((res) => {
      this.vehicleList = res.customsVehicleItems || [];
    });
  },
  data() {
    return {
      form: [
        {
          licensePlate: "",
          carrierCodes: [],
          carrierCodeDesc: [],
          applicant: "翁凌骞",
        },
      ],
      visible: false,
      loading: false,
      dataList: [],
      vehicleList: [],
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "编号",
          width: 200,
          key: "checklistOrderNo",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            return (
              <a
                style={{ color: "#409EFF", padding: "0 10px" }}
                onClick={() => this.showDetail(row.checklistOrderNo)}
              >
                {row.checklistOrderNo}
              </a>
            );
          },
        },
        {
          title: "预录入单号",
          width: 200,
          key: "preChecklistOrderNo",
          align: "center",
        },
        {
          title: "核放单号",
          key: "realChecklistOrderNo",
          width: 200,
          align: "center",
          render: (h, param) => {
            let row = param.row;
            return row.checklistStatus === "CUSTOMS_DECLARING" ? (
              <popover
                row={row}
                prop="realChecklistOrderNo"
                onOrderNoChange={this.orderNoChange.bind(this)}
              />
            ) : (
              <span>{row.realChecklistOrderNo}</span>
            );
          },
        },
        {
          title: "关联车辆信息",
          width: 150,
          key: "licensePlate",
          align: "center",
          // render: (h, param) => {
          //   let row = param.row;
          //   return (
          //     <popover
          //       row={row}
          //       prop="licensePlate"
          //       onOrderNoChange={this.refreshData.bind(this)}
          //     ></popover>
          //   );
          //   // return row.checklistStatus === 'INPUT_WAIT' ? <popover row={row} prop='licensePlate' onOrderNoChange={this.refreshData.bind(this)}></popover> : <span>{row.licensePlate}</span>
          // }
        },
        {
          title: "车自重(KG)",
          width: 120,
          key: "vehicleWeight",
          align: "center",
          // render: (h, param) => {
          //   let row = param.row;
          //   return row.checklistStatus === "INPUT_WAIT" ||
          //     row.checklistStatus === "INPUT_COMPLETED" ||
          //     row.checklistStatus === "CUSTOMS_DECLARING" ||
          //     row.checklistStatus === "CUSTOMS_EXCEPTION" ? (
          //     <popover
          //       row={row}
          //       prop="vehicleWeight"
          //       onOrderNoChange={this.refreshData.bind(this)}
          //     ></popover>
          //   ) : (
          //     <span>{row.vehicleWeight}</span>
          //   );
          // }
        },
        {
          title: "车架编号",
          width: 120,
          key: "vehicleFrameNo",
          align: "center",
          // render: (h, param) => {
          //   let row = param.row;
          //   return row.checklistStatus === "INPUT_WAIT" ||
          //     row.checklistStatus === "INPUT_COMPLETED" ||
          //     row.checklistStatus === "CUSTOMS_DECLARING" ||
          //     row.checklistStatus === "CUSTOMS_EXCEPTION" ? (
          //     <popover
          //       row={row}
          //       prop="vehicleFrameNo"
          //       onOrderNoChange={this.refreshData.bind(this)}
          //     ></popover>
          //   ) : (
          //     <span>{row.vehicleFrameNo}</span>
          //   );
          // }
        },
        {
          title: "车架重",
          width: 120,
          key: "vehicleFrameWeight",
          align: "center",
          // render: (h, param) => {
          //   let row = param.row;
          //   return row.checklistStatus === "INPUT_WAIT" ||
          //     row.checklistStatus === "INPUT_COMPLETED" ||
          //     row.checklistStatus === "CUSTOMS_DECLARING" ||
          //     row.checklistStatus === "CUSTOMS_EXCEPTION" ? (
          //     <popover
          //       row={row}
          //       prop="vehicleFrameWeight"
          //       onOrderNoChange={this.refreshData.bind(this)}
          //     ></popover>
          //   ) : (
          //     <span>{row.vehicleFrameWeight}</span>
          //   );
          // }
        },
        {
          title: "申请人",
          width: 120,
          key: "applicant",
          align: "center",
        },
        {
          title: "快递公司",
          width: 120,
          key: "carrierCodeDesc",
          align: "center",
        },
        {
          title: "创建时间",
          width: 200,
          key: "gmtCreateTime",
          align: "center",
          render: (h, param) => {
            let date = param.row.gmtCreateTime || "";
            return <p>{formatDate(date)}</p>;
          },
        },
        {
          title: "回执时间",
          width: 200,
          key: "enterFinishTime",
          align: "center",
          render: (h, param) => {
            let date = param.row.enterFinishTime || "";
            return <p>{formatDate(date)}</p>;
          },
        },
        {
          title: "状态",
          width: 180,
          key: "checklistStatus",
          align: "center",
          render: (h, param) => {
            if (!param.row && !param.row.checklistStatus) return;
            return <div>{this.statusDist[param.row.checklistStatus]}</div>;
          },
        },
        {
          title: "海关回执状态",
          width: 180,
          key: "customsReturnStatus",
          align: "center",
          // render: (h, param) => {
          // 	if (!param.row && !param.row.checklistStatus) return
          // 	return <div>{this.statusDist[param.row.checklistStatus]}</div>
          // }
        },
        {
          title: "海关回执信息",
          width: 180,
          key: "customsCheckInfo",
          align: "center",
          // render: (h, param) => {
          // 	if (!param.row && !param.row.checklistStatus) return
          // 	return <div>{this.statusDist[param.row.checklistStatus]}</div>
          // }
        },
        {
          title: "操作",
          align: "center",
          fixed: "right",
          width: 300,
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.exportData.bind(
                    this,
                    row && row.checklistOrderNo
                  )}
                >
                  导出
                </a>
                {row.checklistStatus === "INPUT_COMPLETED" ||
                row.checklistStatus === "CUSTOMS_EXCEPTION" ||
                row.isEmptyVehicleCheck === "1" ? (
                  <a
                    style={{ color: "#409EFF", padding: "0 10px" }}
                    onClick={() => {
                      this.declareChecklistOrder({
                        request: {
                          checklistOrderNo: row.checklistOrderNo,
                        },
                      }).then((res) => {
                        if (res.value) {
                          this.$message.success("推送成功");
                          this.fetch();
                        }
                      });
                    }}
                  >
                    推送
                  </a>
                ) : null}
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={() => {
                    this.editVisible = true;
                    this.editRow = JSON.parse(JSON.stringify(row));
                  }}
                >
                  编辑
                </a>
                {row.checklistStatus !== "CUSTOMS_APPROVED" &&
                  row.checklistStatus !== "CLOSE" && (
                    <a
                      style={{ color: "#409EFF", padding: "0 10px" }}
                      onClick={() => this.invalidData(row)}
                    >
                      作废
                    </a>
                  )}
              </div>
            );
          },
        },
      ],
      filterObj: {
        popName: "",
        checklistNo: "",
        licensePlate: "",
        expressCode: "",
        checklistStatus: "",
        applyTime: [],
        applyTime2: [],
      },
      currentRow: [],
      statusDist: {
        INPUT_WAIT: "创建成功，待录入",
        INPUT_COMPLETED: "运单信息录入完成",
        CUSTOMS_APPROVED: "核放单关联完成",
        CLOSE: "核放单已作废",
        CUSTOMS_DECLARING: "申报中",
        CUSTOMS_EXCEPTION: "异常",
      },
      pushDisabled: false,
      editVisible: false,
      editRow: {
        licensePlate: "",
        vehicleFrameNo: "",
        vehicleFrameWeight: "",
        vehicleWeight: "",
      },
      nuclearNoteList: [],
    };
  },
  computed: {
    ...mapState("danding", {
      carrierAllList: "carrierAllList",
    }),
  },
  methods: {
    ...mapActions("danding", [
      "fetchNuclearReleaseList",
      "addNuclearReleaseList",
      "closeNuclearRelease",
      "enterNuclearReleaseOrder",
      "exportNuclearReleaseList",
      "fetchNuclearReleaseDetail",
      "updateNuclearReleaseOrder",
      "fetchCarrierAllList",
      "exportNuclearReleaseBaseInfo",
      "declareChecklistOrder",
      "queryVehicleList",
      "nuclearPageQuery",
    ]),
    typeChange(value) {},
    fetchNuclearNoteList() {
      this.nuclearPageQuery({
        request: {
          // endorsementStatus: "CUSTOMS_CLOSING",
          currentPage: 1,
          pageSize: 99999,
        },
      }).then((res) => {
        this.nuclearNoteList = res.customsEndorsementOrderItemList || [];
      });
    },
    resetEditForm() {
      this.editRow = {
        licensePlate: "",
        vehicleFrameNo: "",
        vehicleFrameWeight: "",
        vehicleWeight: "",
      };
      this.editVisible = false;
    },
    submitEditForm() {
      if (!this.editRow.licensePlate) {
        this.$message.warning("车牌信息不能为空");
        return;
      }
      if (!this.editRow.vehicleFrameNo) {
        this.$message.warning("车架号不能为空");
        return;
      }
      if (!this.editRow.vehicleFrameWeight) {
        this.$message.warning("车架重量不能为空");
        return;
      }
      if (!this.editRow.vehicleWeight) {
        this.$message.warning("车自重不能为空");
        return;
      }
      this.updateNuclearReleaseOrder({
        request: this.editRow,
      })
        .then((res) => {
          if (res) {
            this.fetch();
            this.loading = false;
            this.editRow = {
              licensePlate: "",
              vehicleFrameNo: "",
              vehicleFrameWeight: "",
              vehicleWeight: "",
            };
            this.editVisible = false;
            this.$message.success("修改信息成功");
          }
        })
        .catch((err) => {
          this.$message.error("修改信息失败");
          this.loading = false;
          this.editRow = {
            licensePlate: "",
            vehicleFrameNo: "",
            vehicleFrameWeight: "",
            vehicleWeight: "",
          };
          this.editVisible = false;
        });
    },
    getNewValue(ite, index) {
      ite.index = index;
      return JSON.stringify(ite);
    },
    selectChange(e) {
      if (e.indexOf("{") !== -1) {
        e = JSON.parse(e);
        this.vehicleList.map((item) => {
          if (item.licensePlate === e.licensePlate) {
            this.form[e.index].licensePlate = e.licensePlate;
            this.form[e.index].vehicleFrameNo = e.vehicleFrameNo;
            this.form[e.index].vehicleFrameWeight = e.vehicleFrameWeight;
            this.form[e.index].vehicleWeight = e.vehicleWeight;
          }
        });
      }
    },
    selectChange2(e) {
      if (e.indexOf("{") !== -1) {
        e = JSON.parse(e);
        this.vehicleList.map((item) => {
          if (item.licensePlate === e.licensePlate) {
            this.editRow.licensePlate = e.licensePlate;
            this.editRow.vehicleFrameNo = e.vehicleFrameNo;
            this.editRow.vehicleFrameWeight = e.vehicleFrameWeight;
            this.editRow.vehicleWeight = e.vehicleWeight;
          }
        });
      }
    },
    push() {
      let checklistOrderNo = [];
      this.currentRow.map((item) => {
        if (
          item.checklistStatus === "INPUT_COMPLETED" ||
          item.checklistStatus === "CUSTOMS_EXCEPTION"
        ) {
          checklistOrderNo.push(item);
        }
      });
      if (checklistOrderNo.length === 0) {
        this.$message.warning("当前暂无可推送数据");
        return;
      }
      this.declareChecklistOrder({
        request: { checklistOrderNo },
      })
        .then((res) => {
          if (res.value) {
            this.$message.success("推送成功");
            this.fetch();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetForm() {
      this.form = [
        {
          licensePlate: "",
          carrierCodes: [],
          carrierCodeDesc: [],
          weightRequired: "",
          enableCPOrderValid: "",
          applicant: "翁凌骞",
        },
      ];
      this.visible = false;
    },
    refreshData(row, prop, value) {
      this.loading = true;
      let request = row;
      request[prop] = value;
      this.updateNuclearReleaseOrder({
        request,
      })
        .then((res) => {
          if (res) {
            this.fetch();
            this.loading = false;
            this.$message.success("修改信息成功");
          }
        })
        .catch((err) => {
          this.$message.error("修改信息失败");
          this.loading = false;
        });
    },
    exportList() {
      let list = [];
      if (this.currentRow.length === 0) return;
      this.currentRow.map((v) => {
        list.push(v.checklistOrderNo);
      });
      this.loading = true;
      this.exportNuclearReleaseBaseInfo({
        request: { checklistOrderNos: list },
      })
        .then((res) => {
          if (res.value) {
            this.$alert("提交成功", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({ name: "download" });
              },
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    findCarrierCode(desc) {
      let arr = [];
      this.carrierAllList.map((v) => {
        desc.map((descItem) => {
          if (v.name === descItem) {
            arr.push(v.code);
          }
        });
      });
      return arr;
    },
    // 新建核放单
    submitForm() {
      let customsChecklistOrderItems = [];
      let flag = false;
      this.form.map((v) => {
        if (
          v.licensePlate &&
          v.carrierCodeDesc &&
          v.carrierCodeDesc.length &&
          v.vehicleWeight &&
          v.vehicleFrameNo &&
          v.vehicleFrameWeight &&
          v.applicant &&
          v.checklistType &&
          v.isEmptyVehicleCheck
        ) {
          v.carrierCodes = this.findCarrierCode(v.carrierCodeDesc);
          customsChecklistOrderItems.push({
            licensePlate:
              v.licensePlate.indexOf("{") !== -1
                ? JSON.parse(v.licensePlate).licensePlate
                : v.licensePlate,
            carrierCodes: v.carrierCodes,
            weightRequired: v.weightRequired ? "1" : "0",
            enableCPOrderValid: v.enableCPOrderValid ? "1" : "0",
            vehicleWeight: v.vehicleWeight,
            vehicleFrameNo: v.vehicleFrameNo,
            vehicleFrameWeight: v.vehicleFrameWeight,
            applicant: v.applicant,
            isEmptyVehicleCheck: v.isEmptyVehicleCheck,
            checklistType: v.checklistType,
            endorsementOrderNos: v.endorsementOrderNos,
          });
        } else {
          flag = true;
          if (!v.licensePlate.trim()) {
            this.$message.warning("请输入车辆信息");
          } else if (!v.vehicleWeight) {
            this.$message.warning("请输入车辆自重");
          } else if (!v.vehicleFrameNo) {
            this.$message.warning("请输入车架号");
          } else if (!v.vehicleFrameWeight) {
            this.$message.warning("请输入车架重");
          } else if (!v.applicant) {
            this.$message.warning("请选择申请人");
          } else if (!v.isEmptyVehicleCheck) {
            this.$message.warning("请选择核放单类型");
          } else if (!v.checklistType) {
            this.$message.warning("请选择进出区标志");
          } else {
            this.$message.warning("请选择快递公司");
          }
        }
      });
      if (flag) return;
      if (!customsChecklistOrderItems.length) return;
      this.addNuclearReleaseList({
        request: { customsChecklistOrderItems },
      })
        .then((res) => {
          if (res.value) {
            this.fetch();
          }
          this.form = this.visible = false;
          this.loading = false;
        })
        .catch((err) => {
          this.form = [
            {
              licensePlate: "",
              carrierCodes: [],
              carrierCodeDesc: [],
              applicant: "翁凌骞",
            },
          ];
          this.loading = false;
          this.visible = false;
        });
    },
    addForm() {
      this.form.push({
        licensePlate: "",
        carrierCodes: [],
        carrierCodeDesc: [],
        applicant: "翁凌骞",
      });
    },
    // 批量作废
    // invalidList() {
    //   let customsChecklistNos = [];
    //   if (this.currentRow.length === 0) return;
    //   let flag = false;
    //   this.currentRow.map(v => {
    //     if (v.checklistStatus === "INPUT_WAIT") {
    //       customsChecklistNos.push(v.checklistOrderNo);
    //     } else {
    //       flag = true;
    //     }
    //   });
    //   if (flag) {
    //     this.$message.warning("此状态不可以作废");
    //     return;
    //   }
    //   if (customsChecklistNos.length === 0) {
    //     this.$message.warning("请选择尚未作废的数据");
    //     return;
    //   }
    //   this.$confirm("确定要将选中的核放单作废吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消"
    //   })
    //     .then(res => {
    //       this.loading = true;
    //       this.closeNuclearRelease({
    //         request: { customsChecklistNos }
    //       })
    //         .then(res => {
    //           if (res.value) {
    //             this.fetch();
    //             this.$message.success("作废成功");
    //           } else {
    //             this.$message.error("作废失败");
    //           }
    //           this.loading = false;
    //         })
    //         .catch(err => {
    //           this.loading = false;
    //           this.$message.error("作废失败");
    //         });
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },
    // 作废单条数据
    invalidData(row) {
      this.$confirm("确定要将选中的核放单作废吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then((res) => {
          this.loading = true;
          this.closeNuclearRelease({
            request: { customsChecklistNo: row.checklistOrderNo },
          })
            .then((res) => {
              if (res.value) {
                this.fetch();
                this.$message.success("作废成功");
              } else {
                this.$message.error(res.msg);
              }
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err.msg);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 添加真实核注单号
    orderNoChange(row, prop, realChecklistOrderNo) {
      this.loading = true;
      this.enterNuclearReleaseOrder({
        request: {
          checklistOrderNo: row.checklistOrderNo,
          realChecklistOrderNo,
        },
      })
        .then((res) => {
          if (res.value) {
            this.fetch();
            this.$message.success("修改成功");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 取消退货申请
    cancelReturn(id) {
      if (this.currentRow.length === 0 && !id) return;
      let list = [];
      if (id) {
        list.push(id);
      } else {
        this.currentRow.map((v) => {
          // 退货状态为初始化状态和待退货状态可以取消退货申请
          if (v.returnStatus === "INIT" || v.returnStatus === "WAIT_return") {
            list.push(v.id);
          }
        });
      }
      if (list.length === 0) {
        this.$message.warning(`请选择支持取消退货申请的订单`);
        return;
      }
      this.$confirm("是否确定取消退货订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then((res) => {
          this.cancelGoodsReturn({
            request: { customsGoodsReturnOrderNos: list },
          }).then((res) => {
            if (res.failureList.length) {
              this.$message.warning(
                `有${res.failureList.length}条数据提交失败`
              );
            }
            this.fetch();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        filterParams.gmtCreateTimeStart = new Date(
          filterParams.applyTime[0] + " 00:00:00"
        ).getTime();
        filterParams.gmtCreateTimeEnd = new Date(
          filterParams.applyTime[1] + " 23:59:59"
        ).getTime();
        delete filterParams.applyTime;
      } else {
        delete filterParams.gmtCreateTimeStart;
        delete filterParams.gmtCreateTimeEnd;
      }
      if (filterParams.applyTime2 != null) {
        filterParams.enterFinishTimeStart = new Date(
          filterParams.applyTime2[0] + " 00:00:00"
        ).getTime();
        filterParams.enterFinishTimeEnd = new Date(
          filterParams.applyTime2[1] + " 23:59:59"
        ).getTime();
        delete filterParams.applyTime2;
      } else {
        delete filterParams.enterFinishTimeStart;
        delete filterParams.enterFinishTimeEnd;
      }
      let searchCondition = {
        request: {
          ...filterParams,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      };
      this.fetchNuclearReleaseList(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.customsChecklistOrderItems || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    selectionChange(rows) {
      this.currentRow = rows;
      let flag = false;
      rows.map((item) => {
        if (
          item.checklistStatus !== "CUSTOMS_EXCEPTION" &&
          item.checklistStatus !== "INPUT_COMPLETED"
        ) {
          flag = true;
        }
      });
      this.pushDisabled = flag;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "搜索",
              model: "popName",
              type: type.INPUT,
              placeholder: "请输入车辆信息、核放单号、编号",
            },
            {
              label: "快递公司",
              model: "carrierCode",
              placeholder: "支持模糊搜索",
              type: type.SELECT,
              props: {
                data: this.calculateArr(this.carrierAllList),
              },
            },
            {
              label: "核放单状态",
              model: "checklistStatus",
              type: type.SELECT,
              props: {
                data: [
                  { value: "INPUT_WAIT", label: "创建成功，待录入" },
                  { value: "INPUT_COMPLETED", label: "运单信息录入完成" },
                  { value: "CUSTOMS_APPROVED", label: "核放单关联完成" },
                  { value: "CLOSE", label: "核放单已作废" },
                  { value: "CUSTOMS_DECLARING", label: "核放单申报中" },
                  { value: "CUSTOMS_EXCEPTION", label: "核放单异常" },
                ],
              },
            },
            {
              label: "创建时间",
              model: "applyTime",
              type: type.DATE_RANGE,
              className: "flex-form-item",
            },
            {
              label: "录入时间",
              model: "applyTime2",
              type: type.DATE_RANGE,
              className: "flex-form-item",
            },
          ],
        },
      ];
    },
    // 将快递列表转为可供select组件使用的数组
    calculateArr(arr) {
      if (!arr || !arr.length) return;
      let theArr = [];
      arr.map((v) => {
        theArr.push({
          value: v.code,
          label: v.name,
        });
      });
      return theArr;
    },
    // 转到详情页
    showDetail(id) {
      console.log(id);
      if (!id) return;
      this.$router.push({
        name: "checkListDetail",
        params: { id: id || 0 },
      });
    },
    // 导出数据
    exportData(id) {
      this.loading = true;
      if (typeof id !== "string") return;
      this.exportNuclearReleaseList({
        request: {
          checklistOrderNos: [id],
        },
      }).then((res) => {
        this.loading = false;
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$router.push({ name: "download" });
            },
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    },
  },
};
</script>

<style lang="scss">
.row-div {
  padding-right: 30px;
  position: relative;
  button {
    position: absolute;
    right: 60px;
    bottom: -10px;
  }
}
.avatar-uploader {
  display: inline-block;
}
.inline-p {
  display: inline-block;
}
.inline-p span {
  color: #3399ff;
}

.el-dialog .el-dialog__body {
  padding-top: 0;
}
.el-button--text::after {
  background-color: #fff;
}
.dialog .el-form-item__label::before {
  content: "*";
  color: #ff3333;
  margin-right: 4px;
}
.dialog .none .el-form-item__label::before {
  content: "";
  color: #ff3333;
  margin-right: 4px;
}
.el-dialog__footer {
  text-align: center;
}
.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
.el-form-item__content {
  width: 250px;
}
.filter_con .el-input {
  width: 100%;
}
</style>
